// src/components/Celebrations/CelebrationSpeechTab.js
import React, { useState, useRef, useEffect } from "react";
import html2pdf from "html2pdf.js";
import { useDispatch, useSelector } from "react-redux";
import { fetchSpeechThunk } from "../../redux/fetchProjectsThunk";
import userStore from "../../../../zustand/userStore";
import {
  lclUserAIIntegration,
  UserAIIntegration,
} from "../../../../configs/WebService";
import moment from "moment";

const CelebrationSpeechTab = ({ item, category_id = 0 }) => {
  const [selectedSpeechType, setSelectedSpeechType] = useState("");
  const [typedPrompt, setTypedPrompt] = useState("");
  const [displayedSpeech, setDisplayedSpeech] = useState("");
  const [isLoadingAiSpeech, setIsLoadingAiSpeech] = useState(false);
  const [aiError, setAiError] = useState(null);
  const [language, setLanguage] = useState("English");

  const dispatch = useDispatch();
  const speechRef = useRef();

  const userData = userStore((state) => state.user);
  const user_id = userData.admin_id;
  //Setting up user ai credentials
  //Fetch data here to put
  const models = userStore((state) => state.models);
  const selectedModelId = userStore((state) => state.selectedModelId);
  const setSelectedModelId = userStore((state) => state.setSelectedModelId);
  const fetchUserModels = userStore((state) => state.fetchUserModels);
  useEffect(() => {
    fetchUserModels(user_id);
  }, [fetchUserModels]);
  const handleSelectModel = (modelId) => {
    setSelectedModelId(modelId);
  };
  const categoryKey = category_id === 0 ? "celebration" : "awareness";

  const {
    speeches = {
      staticSpeeches: { shortSpeech: [], longSpeech: [] },
      aiPrompts: [],
    },
    loading: loadingSpeech,
    error: fetchError,
  } = useSelector((state) => state.projects.eventDetails[categoryKey] || {});

  const staticSpeeches = speeches.staticSpeeches || {
    shortSpeech: [],
    longSpeech: [],
  };
  const aiPrompts = speeches.aiPrompts || [];

  useEffect(() => {
    if (item?.celebration_id) {
      dispatch(
        fetchSpeechThunk({
          category_id,
          event_id: item.celebration_id,
          language,
        }),
      );
    }
  }, [dispatch, category_id, item?.celebration_id, language]);

  useEffect(() => {
    if (
      selectedSpeechType === "shortSpeech" &&
      staticSpeeches.shortSpeech?.length > 0
    ) {
      const combined = staticSpeeches.shortSpeech
        .map(
          (speech, i) =>
            `--- <strong>Speech ${i + 1}</strong>: <strong>${
              speech.title
            }</strong>---\n\n${speech.content}`,
        )
        .join("\n\n\n");
      setDisplayedSpeech(combined);
    } else if (
      selectedSpeechType === "longSpeech" &&
      staticSpeeches.longSpeech?.length > 0
    ) {
      const combined = staticSpeeches.longSpeech
        .map(
          (speech, i) =>
            `--- <strong>Speech ${i + 1}</strong>: <strong>${
              speech.title
            }</strong>---\n\n${speech.content}`,
        )
        .join("\n\n\n");
      setDisplayedSpeech(combined);
    } else if (selectedSpeechType === "aiGenerated") {
      setDisplayedSpeech("");
    } else {
      setDisplayedSpeech("");
    }
  }, [selectedSpeechType, staticSpeeches]);

  const handleGenerateAiSpeech = async () => {
    if (!typedPrompt) {
      setAiError("Please enter a prompt.");
      return;
    }

    setIsLoadingAiSpeech(true);
    setAiError(null);
    setDisplayedSpeech("");

    const question = `Generate a speech ${typedPrompt}`;

    try {
      const response = await fetch(`${UserAIIntegration}/askAi`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id,
          ai_model_id: selectedModelId,
          question,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result?.message || "Failed to get AI response.");
      }

      const answer = result?.answer || "No response from AI.";
      setDisplayedSpeech(answer);
    } catch (err) {
      setAiError("Error: " + err.message);
      setDisplayedSpeech("Unable to generate response.");
    } finally {
      setIsLoadingAiSpeech(false);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(displayedSpeech);
    alert("Speech copied to clipboard!");
  };

  const handlePrint = () => {
    if (speechRef.current && displayedSpeech) {
      const printWindow = window.open("", "", "width=800,height=600");
      printWindow.document.write(
        "<html><head><title>Print</title></head><body>",
      );
      printWindow.document.write(`<h1>${item.name || item.details}</h1>`);
      // printWindow.document.write(`<h4>Date: ${moment(item.date, "DD-MM-YYYY").format("MMMM D, YYYY")}</h4>`);
      // printWindow.document.write(`<pre>${displayedSpeech}</pre>`);
      printWindow.document.write(`
  <div style="
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 16px;
    line-height: 1.4;
    padding: 15px;
    font-family: Arial, sans-serif;
  ">
    ${displayedSpeech}
  </div>
`);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.print();
    }
  };

  // const handleDownloadPdf = () => {
  //   if (speechRef.current && displayedSpeech) {
  //     const element = document.createElement("div");
  //     element.innerHTML = `<h1>${item.name || item.details}</h1>
  //       <pre>${displayedSpeech}</pre>`;
  //     html2pdf()
  //       .from(element)
  //       .save(`${item.name || "celebration"}-speech.pdf`);
  //   }
  // };

  const handleDownloadPdf = () => {
    if (speechRef.current && displayedSpeech) {
      const element = document.createElement("div");

      element.innerHTML = `
      <div style="
        padding: 20px;
        font-family: Arial, sans-serif;
        width: 100%;
        box-sizing: border-box;
        word-wrap: break-word;
        overflow-wrap: break-word;
      ">
        <h2 style="margin-bottom: 20px;">
          ${item.name || item.details}
        </h2>

        <div style="
          white-space: pre-wrap;
          word-break: break-word;
          line-height: 1.6;
          font-size: 14px;
        ">
          ${displayedSpeech}
        </div>
      </div>
    `;

      const opt = {
        margin: [10, 10, 10, 10],
        filename: `${item.name || "celebration"}-speech.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          scale: 2,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
        pagebreak: {
          mode: ["avoid-all", "css", "legacy"],
        },
      };

      html2pdf().set(opt).from(element).save();
    }
  };
  const applyMultiColumnPrompts = aiPrompts.length > 10;

  return (
    <div className="card card-body">
      <div className="d-flex justify-content-between mb-2">
        <div>
          <h3 className="my-0 text-18">
            Speech for {item.name || item.details}
          </h3>
          <p className="m-0">Select a speech type or generate one using AI.</p>
        </div>
        <div className="d-flex align-items-start gap-2">
          <div className="input-group mb-0 me-2" style={{ width: "150px" }}>
            <select
              className="form-select"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            >
              <option value="English">English</option>
              <option value="Hindi">Hindi</option>
            </select>
          </div>
          <button
            className="btn btn-primary"
            onClick={handleCopy}
            disabled={!displayedSpeech}
          >
            Copy
          </button>
          <button
            className="btn btn-primary"
            onClick={handlePrint}
            disabled={!displayedSpeech}
          >
            Print
          </button>
          <button
            className="btn btn-primary"
            onClick={handleDownloadPdf}
            disabled={!displayedSpeech}
          >
            Download PDF
          </button>
          {
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              {Array.isArray(models) &&
              models.length > 1 &&
              selectedSpeechType === "aiGenerated" ? (
                <select
                  className="form-select"
                  value={selectedModelId || ""}
                  onChange={(e) => handleSelectModel(Number(e.target.value))}
                >
                  <option value="" disabled>
                    Select a model
                  </option>
                  {models.map((model) => (
                    <option key={model.model_id} value={model.model_id}>
                      {model.name} — Verified: {model.verified ? "Yes" : "No"}
                    </option>
                  ))}
                </select>
              ) : null}
            </div>
          }
        </div>
      </div>

      <div className="mb-2">
        <label htmlFor="speechTypeSelect" className="form-label">
          Choose Speech Type:
        </label>
        <select
          id="speechTypeSelect"
          className="form-select"
          value={selectedSpeechType}
          onChange={(e) => {
            setSelectedSpeechType(e.target.value);
            setTypedPrompt("");
            setAiError(null);
          }}
        >
          <option value="">-- Select --</option>
          <option value="shortSpeech">Short Speech</option>
          <option value="longSpeech">Long Speech</option>
          <option value="aiGenerated">Generate using AI</option>
        </select>
      </div>

      {selectedSpeechType === "aiGenerated" && (
        <div className="mb-2">
          <label htmlFor="typedPrompt" className="form-label">
            Type a prompt:
          </label>
          <input
            type="text"
            id="typedPrompt"
            className="form-control mb-3"
            value={typedPrompt}
            onChange={(e) => setTypedPrompt(e.target.value)}
            placeholder="e.g., Write a speech for Independence Day"
            disabled={isLoadingAiSpeech}
          />
          <button
            className="btn btn-success mb-3"
            onClick={handleGenerateAiSpeech}
            disabled={!typedPrompt || isLoadingAiSpeech}
          >
            {isLoadingAiSpeech ? "Generating..." : "Generate"}
          </button>
          {aiError && <div className="alert alert-danger mt-2">{aiError}</div>}

          {aiPrompts.length > 0 && (
            <div className="mb-3">
              <h6>Suggested Prompts:</h6>
              <div
                style={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  border: "1px solid #e0e0e0",
                  padding: "10px",
                }}
              >
                <ul
                  className="list-group"
                  style={
                    applyMultiColumnPrompts
                      ? {
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fit, minmax(250px, 1fr))",
                          gap: "10px",
                        }
                      : {}
                  }
                >
                  {aiPrompts.map((prompt, idx) => (
                    <li
                      key={idx}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <span dangerouslySetInnerHTML={{ __html: prompt }} />
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => setTypedPrompt(stripHtmlTags(prompt))}
                      >
                        Use Prompt
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      )}

      {selectedSpeechType && displayedSpeech && (
        <div className="mb-3">
          <h4>Speech Content:</h4>
          {/* <div
            ref={speechRef}
            style={{
              whiteSpace: "pre-wrap",
              backgroundColor: "#f8f9fa",
              padding: "1rem",
              border: "1px solid #ddd",
              minHeight: "100px",
              maxHeight: "400px",
              overflowY: "auto",
            }}
          > */}
          <div
            ref={speechRef}
            style={{
              whiteSpace: "pre-wrap",
              backgroundColor: "#f8f9fa",
              padding: "1rem",
              border: "1px solid #ddd",
              minHeight: "100px",
              maxHeight: "400px",
              overflowY: "auto",

              wordWrap: "break-word",
              overflowWrap: "break-word",
              wordBreak: "break-word",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            {loadingSpeech && <p>Loading speeches...</p>}
            {fetchError && (
              <p className="text-danger">
                Error fetching speeches: {fetchError.message || fetchError}
              </p>
            )}
            <div dangerouslySetInnerHTML={{ __html: displayedSpeech }} />
          </div>
        </div>
      )}

      {!selectedSpeechType && (
        <div className="alert alert-info mb-3">
          Please select a speech type from the dropdown above to begin.
        </div>
      )}
    </div>
  );
};

export default CelebrationSpeechTab;
const stripHtmlTags = (htmlString) => {
  const doc = new DOMParser().parseFromString(htmlString, "text/html");
  return doc.body.textContent || "";
};
